import { stringify } from '@angular/compiler/src/util';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from 'src/app/core/services/product.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit, OnDestroy {

  //#region ProductComponent constructor & Ng Events
  constructor(private productService: ProductService, private route: ActivatedRoute) { }
  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
  }
  ngOnInit(): void {
    this.paramsSubscription = this.route.params.subscribe(params => {
      console.log('The id of this route is: ', params.id);
      this.products.productCategoryId= params.id;
    });
    const body = {
      productCategoryId: this.products.productCategoryId,
      languageCode: localStorage.getItem('language')
    }
    this.productService.getProductsByCategoryId(body).subscribe((products) => {
      console.log(products);
      this.products.products = products;
    });
  }
  //#endregion
  //#region ProductComponent Business Logic 
  private paramsSubscription: Subscription;
  protected products = {
    products: this.productService.products,
    productCategoryId:0
  }
  //#endregion

}
